"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var SettingsZonesOverviewDTO_1 = require("../../model/dto/SettingsZonesOverviewDTO");

var SettingsZonesOverviewDTOConverter_1 = require("./SettingsZonesOverviewDTOConverter");
/**
 * Default implementation of {@link SettingsZonesOverviewDTOConverter}.
 *
 * @author RV
 */


var SettingsZonesOverviewDTOConverterImpl =
/*#__PURE__*/
function (_SettingsZonesOvervie) {
  _inherits(SettingsZonesOverviewDTOConverterImpl, _SettingsZonesOvervie);

  function SettingsZonesOverviewDTOConverterImpl() {
    _classCallCheck(this, SettingsZonesOverviewDTOConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(SettingsZonesOverviewDTOConverterImpl).apply(this, arguments));
  }

  _createClass(SettingsZonesOverviewDTOConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new SettingsZonesOverviewDTO_1.SettingsZonesOverviewDTO(source.zoneId, source.isInherited);
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, {
        zoneId: source.zoneId,
        isInherited: source.isInherited
      });
      return result;
    }
  }]);

  return SettingsZonesOverviewDTOConverterImpl;
}(SettingsZonesOverviewDTOConverter_1.SettingsZonesOverviewDTOConverter);

exports.SettingsZonesOverviewDTOConverterImpl = SettingsZonesOverviewDTOConverterImpl;